//Permisos
export const SET_PERMISO = "SET_PERMISO";
export const RESET_SEARCH = "RESET_SEARCH";
export const SEARCH_PERMISOS = "SEARCH_PERMISOS";
export const PERMISOS_RECEIVED = "PERMISOS_RECEIVED";
export const CREATE_NUEVO_PERMISO = "CREATE_NUEVO_PERMISO";
export const SET_PROPERTY_PERMISO = "SET_PROPERTY_PERMISO";
export const TIPOS_PERMISOS_RECIBIDOS = "TIPOS_PERMISOS_RECIBIDOS";
export const PERMISOS_PROYECTO_RECEIVED = "PERMISOS_PROYECTO_RECEIVED";
